import React, { useContext } from "react";
import { AddressSearchContext } from "../../AddressSearchContextContainer";

export const withContext = WrappedComponent => props => {
  const contextProps = useContext(AddressSearchContext);

  return <WrappedComponent {...props} {...contextProps} />;
};
